import { render, staticRenderFns } from "./AcademyCreate.vue?vue&type=template&id=14e2ba5c&scoped=true&"
import script from "./AcademyCreate.vue?vue&type=script&lang=js&"
export * from "./AcademyCreate.vue?vue&type=script&lang=js&"
import style0 from "./AcademyCreate.vue?vue&type=style&index=0&id=14e2ba5c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e2ba5c",
  null
  
)

export default component.exports